/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Preview_LoadInputs */

const en_wc_on_preview_load = /** @type {(inputs: Wc_On_Preview_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load WordCraft in this page`)
};

/**
* | output |
* | --- |
* | "Load WordCraft in this page" |
*
* @param {Wc_On_Preview_LoadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_preview_load = /** @type {((inputs?: Wc_On_Preview_LoadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Preview_LoadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_preview_load(inputs)
});
export { wc_on_preview_load as "wc.on.preview_load" }